function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  opacity: 0.8,
  fill: "#2B2B2B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.382 7l.097 11.52L33 18.618l-.025 2.983-11.471-.097.097 11.47-2.983.026-.098-11.521L7 21.382l.025-2.983 11.47.096-.096-11.47L21.382 7z",
  fill: "#FFF"
}));
function SvgAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default SvgAdd;